import axios from '../../service/index'
import React from 'react'
import { message } from 'antd'
import hljs from 'highlight.js'
import E from 'wangeditor';
import ReactDOM from 'react-dom';
const qiniuUpUrl = 'https://up-z1.qiniup.com'
class wangeditors extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			editorHtml: '',
			editorText: '',
			token: '',
			url: '',
			visible: false,
			content: props.content,
			editor: '',
		}
	}

	shouldComponentUpdate(nextProps) {

		if (this.state.content !== nextProps.content) {
			this.setState({
				content: nextProps.value
			}, () => {
				this.state.editor.txt.html(this.state.content);
			});
			return true;
		} else {

			return false;
		}
	}

	showModal() {
		this.setState({ visible: true })
	}
	handleOk() {
		this.setState({ visible: false })
	}
	componentDidMount() {
		this.getToken()
		console.log(this.state.content)
		let editor = new E(ReactDOM.findDOMNode(this._div))
		this.setState({ editor: editor })
		editor.config.onchange = (html) => {
			this.setState({
				editorHtml: html,
				editorText: editor.txt.text(),
			})
			this.props.getText(html)
			//将html值设为form表单的desc属性值
			// this.props.form.setFieldsValue({
			// 	'analysis': html
			// });
		}
		editor.config.menus = [
			'head',
			'bold',
			'fontSize',
			'fontName',
			'italic',
			'underline',
			'strikeThrough',
			'indent',
			'lineHeight',
			'foreColor',
			'backColor',
			'link',
			'list',
			'todo',
			'justify',
			'quote',
			'table',
			'splitLine',
			'undo',
			'code',
			'redo',
			'image',
		]
		editor.config.languageType = [
			'Bash',
			'C',
			'C#',
			'C++',
			'CSS',
			'Java',
			'JavaScript',
			'JSON',
			'TypeScript',
			'Plain text',
			'Html',
			'XML',
			'SQL',
			'Go',
			'Kotlin',
			'Lua',
			'Markdown',
			'PHP',
			'Python',
			'Shell Session',
			'Ruby',
		]
		editor.config.uploadImgMaxLength = 5;
		editor.config.showLinkImg = false;
		editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
		editor.config.withCredentials = false;
		editor.config.uploadImgTimeout = 5 * 1000;
		let _this = this
		editor.config.customUploadImg = function (resultFiles, insertImgFn) {
			// console.log(resultFiles)
			let imgUrl = ''
			let data = new FormData();
			data.append("token", _this.state.token);
			data.append("file", resultFiles[0]);
			axios({
				method: "POST",
				url: qiniuUpUrl,
				data: data,
				onUploadProgress: function (progressEvent) {
				},
			}).then((res) => {
				imgUrl = _this.state.url + '/' + res.data.key
				insertImgFn(imgUrl);
			});
		};

		editor.highlight = hljs
		editor.create()
		if(this.state.content && this.state.content) {
			editor.txt.append(this.state.content)
		}

	}

	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
				//	this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}



	render() {
		return (
			<div ref={(ref) => this._div = ref}></div>
		)
	}
}

export default wangeditors
